// extracted by mini-css-extract-plugin
export default {"filter-label":"ServiceFilter_filter-label__bfubi"};